exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-reports-page {\n  width: 100%;\n  height: 100%;\n}\n.custom-reports-page .header {\n  width: 100%;\n}\n.custom-reports-page .header .header-title {\n  color: #0B486B;\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 39px;\n  margin-bottom: 20px;\n}\n.custom-reports-page .no-records-found-component {\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n.custom-reports-page .no-records-found-component .nrfc_wrapper .nrfc_content h1 {\n  font-size: 26px;\n}\n.custom-reports-page .content-btns {\n  display: flex;\n  justify-content: flex-end;\n  margin: 4px 0 0.8rem 0;\n}", ""]);

// exports
